import { render, staticRenderFns } from "./homeDashboardBlackFridayStatistic.vue?vue&type=template&id=54600002&scoped=true"
import script from "./homeDashboardBlackFridayStatistic.vue?vue&type=script&lang=js"
export * from "./homeDashboardBlackFridayStatistic.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardBlackFridayStatistic.vue?vue&type=style&index=0&id=54600002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54600002",
  null
  
)

export default component.exports